import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-custom-message',
  templateUrl: './custom-message.component.html',
  styleUrls: ['./custom-message.component.scss']
})
export class CustomMessageComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private _router: Router
  ) { }

  title = '';
  message = '';
  actions = [];

  clicked(action, index) {
    this.activeModal.dismiss();
  }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/custom-message/custom-message.component.ts